import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIconUrl from "../../assets/img/map-marker-pin.svg";
import {
  MAP_DEFAULT_ZOOM,
  MAP_TILE_URL,
  MARKER_ICON_SIZE,
  MARKER_ICON_ANCHOR,
} from "./constants";
import "./propertyMap.scss";

const markerIcon = new L.Icon({
  iconUrl: markerIconUrl,
  iconSize: MARKER_ICON_SIZE,
  iconAnchor: MARKER_ICON_ANCHOR,
});

const isValidCoordinate = (lat, lng) => {
  const latitude = parseFloat(lat);
  const longitude = parseFloat(lng);
  return (
    !isNaN(latitude) &&
    !isNaN(longitude) &&
    latitude >= -90 &&
    latitude <= 90 &&
    longitude >= -180 &&
    longitude <= 180
  );
};

const PropertyMap = ({ latitude, longitude }) => {
  if (!isValidCoordinate(latitude, longitude)) {
    return (
      <div className="map-placeholder">
        <span className="map-placeholder__text">Map not available</span>
      </div>
    );
  }

  const position = [parseFloat(latitude), parseFloat(longitude)];

  return (
    <div className="map-placeholder">
      <MapContainer
        center={position}
        zoom={MAP_DEFAULT_ZOOM}
        zoomControl={true}
        dragging={true}
        scrollWheelZoom={true}
        attributionControl={false}
        className="property-map"
      >
        <TileLayer url={MAP_TILE_URL} subdomains={[""]} />
        <Marker position={position} icon={markerIcon} />
      </MapContainer>
    </div>
  );
};

export default PropertyMap;
